/** @format */

import './select_search_by.scss';
import React from 'react';

// styles

export const SelectSearchBy = props => {
    const {showGroupedByOrders, handleToggleGroupByOrders} = props;
    return (
        <div className="select-search-by-09ug">
            <h4 className="select-search-by-09ug__label">Group By</h4>
            <div className="select-search-by-09ug__btns d-inline-flex justify-content-center justify-content-center">
                <button
                    className={
                        (showGroupedByOrders === true ? 'select--active' : 'select--inactive') +
                        ' select-search-by-09ug__btn  select-search-by-09ug__btn--order'
                    }
                    onClick={handleToggleGroupByOrders}>
                    Order
                </button>
                <button
                    className={
                        (showGroupedByOrders === false ? 'select--active' : 'select--inactive') +
                        ' select-search-by-09ug__btn select-search-by-09ug__btn--design'
                    }
                    onClick={handleToggleGroupByOrders}>
                    Design
                </button>
            </div>
        </div>
    );
};
